<template lang="pug">
  div#particles.js-tilt.background--particles.layer(v-parallax="0.3")
</template>
<script>
let particlesJS = require('particles.js')
particlesJS = window.particlesJS;
export default {
    mounted() {
        particlesJS.load('particles', '/static/particlesjs-config.json', () => {})
    }
}
</script>



// WEBPACK FOOTER //
// src/components/particles.vue